/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.BREW_INDEX = {
  '@AX': ['AX8575'],
  '@CD': ['CDM8992', 'CDM8999'],
  '@CO': ['Coolpad D508', 'Coolpad D510', 'Coolpad E600'],
  '@E4': ['E4255'],
  '@EX': ['EX200!'],
  '@HS': ['HS-E316!'],
  '@HU': [
    'HUAWEI U526',
    'HUAWEI U528',
    'HUAWEI U2801!',
    'HUAWEI U5200!',
    'HUAWEI U5300!',
    'HUAWEI U5310!',
    'HUAWEI U6150!'
  ],
  '@LG': [
    'LG272',
    'LG510',
    'LGE AX840',
    'LGE LG700',
    'LGE LG840',
    'LGE UX700',
    'LGE UX840',
    'LGE VX11K',
    'LGE VX8575',
    'LGE VX9700'
  ],
  '@LN': ['LN240', 'LN510'],
  '@LX': ['LX610'],
  '@M2': ['M260!'],
  '@M3': ['M350!', 'M370!', 'M380!', 'M390!'],
  '@M5': ['M550!', 'M560!'],
  '@NO': ['NOKIA 7705'],
  '@P5': ['P5000'],
  '@P6': ['P6020', 'P6030'],
  '@PA': ['Pantech CDM8992!', 'Pantech CDM8999!', 'Pantech TXT8045!'],
  '@PL': ['PLS M330'],
  '@S2': ['S2151!'],
  '@SA': ['sam-r631', 'sam-r640', 'sam-r900'],
  '@SC': [
    'SCH-B309!',
    'SCH-F839',
    'SCH-M519!',
    'SCH-S559!',
    'SCH-S579!',
    'SCH-U380!',
    'SCH-U485',
    'SCH-U640!',
    'SCH-U660!',
    'SCH-U680!',
    'SCH-U750!',
    'SCH-U820!',
    'SCH-U960!',
    'SCH-W709!',
    'SCH-W799!',
    'SCP-3810',
    'SCP3810',
    'SCP-6750',
    'SCP6760',
    'SCP-6760',
    'SCP6780'
  ],
  '@SG': ['SGH-A937!', 'SGH-A947!'],
  '@SM': ['SM-B690V'],
  '@SP': ['SPH M330', 'SPH-M570', 'Sprint M850'],
  '@TX': ['TXT8045'],
  '@VN': ['VN170!', 'VN250!', 'VN271!', 'VN280!', 'VN360!', 'VN370!', 'VN530'],
  '@VX': ['VX5600!', 'VX9200!', 'VX9600!', 'VX11000!'],
  '@ZT': ['ZTE F-450!', 'ZTE R516!', 'ZTE R518!']
};

/* This file is automatically generated, do not edit manually! */
